var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconReplay = function SvgIconReplay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2 9 7l5 5 1.4-1.4L12.8 8H16A10 10 0 1 1 6 18H4A12 12 0 1 0 16 6h-3.2l2.6-2.6z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconReplay);
export { ForwardRef as ReactComponent };